<template>
  <div style="width:1300px;margin:0 auto;">
  <el-button type="primary" style="margin-top:10px;" @click="$router.go(-1)">返回</el-button>
  <el-card class="box-card" style="width: 1300px;margin:40px auto 40px;">
  <div>
  
    <pdf
      :page="pageNum"
      :src="url"
      @progress="loadedRatio = $event"
      @num-pages="pageTotalNum=$event" 
      ></pdf>
  
        <div style="text-align:center;margin-top:20px;">
            <el-button-group>
                <el-button type="primary" icon="el-icon-arrow-left" size="mini" :disabled="pageNum==1?true:false" @click="prePage">上一页</el-button>
                <el-button type="primary" size="mini" @click="throttle">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                </el-button-group>
                <div style="marginTop: 10px; color: #409EFF">{{ pageNum }} / {{ pageTotalNum }}</div>
        </div>
    

  </div>
   </el-card>
  </div>
 
</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'Pdf',
  components: {
    pdf,
  },
  data() {
    return {
      url: '',
      pageNum: 1,
      pageTotalNum: 1, 
      loadedRatio: 0,
      lastTime:0,
      id:""
    }
  },
  methods: {

    addPractice() {
     this.$http.post("Exam/AddPracticeLog", {
          id:this.id,
        })
        .then((res) => {
            
          if (res.data.isok) {
           
           this.$message.success(res.data.message);

          }
        })
        .catch((err) => {})
 
    },

    throttle(){
    
    let now = new Date().valueOf();
    //第一次点击
        if(this.lastTime == 0){
            this.nextPage()
            this.lastTime = now;
        }else{
            if((now-this.lastTime) > 2000){
                //重置上一次点击时间，2000是我自己设置的2秒间隔，根据自己的需要更改
                this.lastTime = now;
                this.nextPage()
                //添加自己要调用的方法
            }else{
               this.$message.warning("操作过于频繁!");
            }
        }
    },

    // 上一页
    prePage() {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },

    // 下一页
    nextPage() {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
      if(this.pageNum==this.pageTotalNum){
           this.addPractice()
      }

    }
  },
  created(){
      this.url = 'http://fw.hyey.cn'+this.$route.query.url
      this.id  = this.$route.query.id
      
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Gopdf.vue